import GLOBAL from "../../global";
import { useDispatch, useSelector } from "react-redux";
import React, { useContext, useRef } from "react";
import AppContext from "../../contexts/AppContext";
import { useHistory, useLocation } from "react-router-dom";
import CONSTANT from "../../constants/Constant";
import { createAssessment } from "./notification/data/api";
import { toast } from "react-toastify";
import { _getInCompleteAssessmentType, getResumeGroupFromId } from "./dashboardUtills";
import { isEmptyObject } from "../../utils/Utils";
import Info from "../../assets/img/utils/info.svg";
// import { redirectTo } from "../shared/chatbotNew/ChatServices";
import routes from "../../constants/Routes";
import Assessment from "../../models/Assessment";
import { saveIntake } from "../shared/intake-form/intake-form-service";
import useIntakeFrom from "../shared/intake-form/useIntakeFrom";
import {
    setIsShowIsFollowUpPopup, setOpenBiometricMovementAndCautionQuestionContainer, setSelectedTelemedicineInvitationId,
    setShowDetailInstruction, setShowLoadingAtJoinNowBtn, setShowLoadingInConformTelemedicine
} from "../../features/dashboard/dashboardSlice";
import useHandleExpiredAndUpcomingMeetingPopupMsg from "../../hooks/useHandleExpiredAndUpcomingMeetingPopupMsg";
import storageService from "../../utils/StorageService";
import useChatbot from "../shared/chatbotNew/hooks/useChatbot";
import usePurchasedPackage from "./usePurchasedPackage";
import examService from "../../services/ExamService";
import useSweetAlert from "../shared/Popups/sweetAlertComponent/useSweetAlert";
import { useTenantFeatures } from "../../features/tenantFeatures/useTenantFeature";

const useDashboardBody = (callBackFnAfterCloseBot) => {
    const dispatch = useDispatch();
    const location = useLocation();
    const history = useHistory();
    const { isAthleteEnabled, isIntakeTelemedicineFormEnable } = useTenantFeatures();

    const { setTelemedicineProperties, setSelectedTabForEditAssessment, resetTelemedicineKeys, setFollowupForAssessmentPage, setLastIncompletedAssessmentsForAssessmentPage } = useContext(AppContext);
    const { handleOpenIntakeForm, handleCloseIntakeForm, handleSetJoiningTelemedicine } = useIntakeFrom();
    const { getAssessmentAvailabilityStatus, handleOpenUpcomingOrExpiredPopupMessage } = useHandleExpiredAndUpcomingMeetingPopupMsg();
    const { startChatBot } = useChatbot();
    const { createAssessmentFromPackage } = usePurchasedPackage();
    const { showSweetAlert, hideSweetAlert } = useSweetAlert();

    const purchasePackageState = useSelector(state => state.purchasePackage);
    const packages = purchasePackageState.packages || [];

    const notificationInformationOfSelectedAssessment = useRef({});

    const patientId = (GLOBAL.USER_INFO && GLOBAL.USER_INFO['ContactId']) || '';

    const handleNewUser = async (allNotifications) => {
        const autoStartKey = `${CONSTANT.CHATBOT_AUTO_STARTED.KEY}_${patientId}`;
        const hasStarted = storageService.getItem(autoStartKey) === 'true';

        if(GLOBAL.USER_INFO?.IsNewUser && allNotifications.length > 0 && !hasStarted) {
            if(!GLOBAL.USER_INFO?.CreditCardCount && GLOBAL.IS_SUBSCRIPTION_ENABLED) {
                return;
            }

            if(storageService.getItem(CONSTANT.IS_D2C_USER.KEY) === 'true') {
                return;
            }

            const invitationData = allNotifications.slice(0, 1)[0];
            storageService.addItem(autoStartKey, 'true');
            startChatBot(
                invitationData,
                patientId,
                invitationData?.MeetingStart,
                invitationData?.MeetingEnd,
                callBackFnAfterCloseBot || (() => {})
            )
            // dispatch(setOpenChatBot({
            //     invitationData,
            //     patientId,
            //     meetingStart: invitationData?.MeetingStart,
            //     meetingEnd: invitationData?.MeetingEnd,
            //     callBackFnAfterCloseBot: callBackFnAfterCloseBot || (() => {})
            // }));
        }
    }

    const handleRemoteAssistance = () => {
        let query = new URLSearchParams(location?.search);
        let invitationId = query.get('InvGId') || '';
        let bodyRegionListParam = query.get('BodyRegionIds') || '';
        let bodyRegionList = bodyRegionListParam.split(',').map(Number).filter(Boolean);
        let testId = query.get('TestId') || '';
        let isRemoteAssistance = query.get('RA') === 'true'; // Will open self as telemedicine?
        if(isRemoteAssistance && invitationId && bodyRegionList.length > 0 && testId) {
            setTelemedicineProperties(invitationId, bodyRegionList, null, removeURLQueryParams);
        }
    }

    ////TODO: will move conformationAlertContentRef to redux
    const notificationHandler = async (notification, conformationAlertContentRef) => {
        const firstInCompleteGroup = getResumeGroupFromId(notification?.ResumeGroupId)?.key;
        const assessmentAvailabilityStatus = getAssessmentAvailabilityStatus(notification.MeetingStart, notification.MeetingEnd);

        if(
            notification?.TestId &&
            !notification?.IsFollowup &&
            firstInCompleteGroup === CONSTANT.ASSESSMENT_GROUP.BIOMETRIC.key &&
            +notification.InvitationTypeId === CONSTANT.INVITATION_TYPE.Telemedicine &&
            (assessmentAvailabilityStatus === CONSTANT.ASSESSMENT_AVAILABILITY.UPCOMING.KEY || assessmentAvailabilityStatus === CONSTANT.ASSESSMENT_AVAILABILITY.EXPIRED.KEY)
        ) {
            handleOpenUpcomingOrExpiredPopupMessage(assessmentAvailabilityStatus);
        }
        else if(notification?.IsFollowup && !notification?.BaseTestId) {
            handleFollowupNotification(notification, conformationAlertContentRef);
        } else if(notification?.IsLastIncomplete) {
            notificationInformationOfSelectedAssessment.current = notification;
            await handleLastInCompleteAssessmentAction(notification)
        }
        ////TODO: not needed, will remove future
        else if(notification?.TestId && (+notification.InvitationTypeId === CONSTANT.INVITATION_TYPE.Telemedicine)) {
            setTelemedicineProperties(notification.InvitationId, notification.BodyRegionList, onOpenTelemedicineModal, onCloseTelemedicineModal);
            dispatch(setSelectedTelemedicineInvitationId(notification.InvitationId));
        }
        else {
            await startHandler(notification)
        }
    }

    // To start bot
    const startHandler = async (notification) => {
        // It is an old business logic, if any tenant does not want to use chatbot for there case we will first create
        // assessment and then redirect to edit assessment page so that user can fill the assessment data
        // Do not know is this logic is still present at VA portal or not for safety purpose we are keeping this logic
        ////TODO: not needed, will remove future
        if(notification.IsFormBasedIntakeEnabled && !notification.TestId) {
            let testId = await createAssessment(preparePayload(notification.BodyRegionList, notification.InvitationId))
            if(testId) {
                redirectToEditAssessmentPage({...notification, TestId: testId})
            } else {
                toast.error(<div>Failed to create assessment.</div>);
            }
        }
        else if(notification.TestId) {
            //If testId is present then resume the assessment for extra security purpose such that any assessment with
            //having testid can't be started from bot by any chance
            redirectToEditAssessmentPage(notification);
        } else {
           await handleInvitationWithoutTestId(notification);
        }
    }

    const handleInvitationWithoutTestId = async (notification) => {
        if (notification.IsFollowup && notification.BaseTestId) {
            const response = await examService.followUp({
                InvitationId: notification.InvitationId,
                BaseTestId: notification.BaseTestId,
                StartTime: notification.MeetingStart,
                EndTime: notification.MeetingEnd,
                TimeZone: "Eastern Standard Time"
            });
            const { data, success, error } = response;

            if (success) {
                showSweetAlert(
                    {
                        title: 'Update Your Information?',
                        message: 'Would you like to update your background information (Activities of Daily Living, Medical History, Chief Complaints)?',
                        type: CONSTANT.ALERT_TYPE.INFO,
                        onConfirm: () => {
                            hideSweetAlert();
                            if (+notification?.InvitationTypeId === CONSTANT.INVITATION_TYPE.Telemedicine) {
                                setTelemedicineProperties(notification.InvitationId, notification.BodyRegionList, onOpenTelemedicineModal, onCloseTelemedicineModal);
                                dispatch(setSelectedTelemedicineInvitationId(notification.InvitationId));
                            } else if (+notification?.InvitationTypeId === CONSTANT.INVITATION_TYPE.Self) {
                                openBiometricCautionQuestionModal({
                                    ...notification,
                                    TestId: data.TestId
                                });
                            } else {
                                // Do nothing
                            }
                        },
                        onClose: () => {
                            hideSweetAlert();
                        },
                        showCloseBtn: true,
                        onCancel: () => {

                            hideSweetAlert();
                            redirectToEditAssessmentPage({...notification, TestId: data.TestId})
                        },
                        showCancelBtn: true,
                        showConfirmBtn: +notification?.InvitationTypeId !== CONSTANT.INVITATION_TYPE.InClinic,
                        showOkBtn: false,
                        confirmBtnText: +notification?.InvitationTypeId !== CONSTANT.INVITATION_TYPE.InClinic ? 'Resume Assessment' : '',
                        cancelBtnText: 'Update My Background',
                    }
                )
            }
        } else {
            startChatBot(
                notification, //invitationData
                patientId, //patientId
                notification?.MeetingStart, //meetingStart
                notification?.MeetingEnd, //meetingEnd
                callBackFnAfterCloseBot || (() => {}) //callBackFnAfterCloseBot
            )
        }
    };

    const redirectToEditAssessmentPage = (notification) => {
        notificationInformationOfSelectedAssessment.current = notification
        let firstInCompletedGroup = getResumeGroupFromId(notification?.ResumeGroupId);
        let keyOfFirstIncompleteGroup = CONSTANT.ASSESSMENT_GROUP.DEMOGRAPHICS.key;
        if(!isEmptyObject(firstInCompletedGroup)) {
            keyOfFirstIncompleteGroup = firstInCompletedGroup?.key || CONSTANT.ASSESSMENT_GROUP.DEMOGRAPHICS.key;
            if(keyOfFirstIncompleteGroup === CONSTANT.ASSESSMENT_GROUP.BIOMETRIC.key) keyOfFirstIncompleteGroup = CONSTANT.ASSESSMENT_GROUP.DEMOGRAPHICS.key
        }
        setSelectedTabForEditAssessment(keyOfFirstIncompleteGroup);

        // setRedirectToAssessmentPage(true)
        // redirectTo(`${routes.editAssessment}/${notificationInformationOfSelectedAssessment.current.TestId}?groupId=${getResumeGroupFromId(notificationInformationOfSelectedAssessment.current?.ResumeGroupId)?.key}`)
        // history.push(`${routes.editAssessment}/${notificationInformationOfSelectedAssessment.current.TestId}?groupId=${notificationInformationOfSelectedAssessment.current?.ResumeGroupId}`)
        history.push(`${routes.editAssessment}/${notificationInformationOfSelectedAssessment.current.TestId}?groupId=${notificationInformationOfSelectedAssessment.current?.ResumeGroupId || CONSTANT.ASSESSMENT_GROUP.DEMOGRAPHICS.key}`)
    }

    const handleFollowupNotification = (notification, conformationAlertContentRef) => {
        notificationInformationOfSelectedAssessment.current = notification;

        if (notification.InvitationTypeId === CONSTANT.INVITATION_TYPE.Telemedicine) {
            setTelemedicineAlert(conformationAlertContentRef);
        } else if (notification.InvitationTypeId === CONSTANT.INVITATION_TYPE.Self) {
            setSelfInvitationAlert(conformationAlertContentRef);
        } else if(notification.InvitationTypeId === CONSTANT.INVITATION_TYPE.InClinic) {
            setInClinicAlert(conformationAlertContentRef);
        }

        dispatch(setIsShowIsFollowUpPopup(true));
    };

    const handleLastInCompleteAssessmentAction = (notification) => {
        const firstInCompleteGroup = getResumeGroupFromId(notification?.ResumeGroupId)?.key;

        if(firstInCompleteGroup === CONSTANT.ASSESSMENT_GROUP.BIOMETRIC.key && +notification.InvitationTypeId === CONSTANT.INVITATION_TYPE.Self) {
            openBiometricCautionQuestionModal(notification);
        } else if (firstInCompleteGroup === CONSTANT.ASSESSMENT_GROUP.BIOMETRIC.key && +notification.InvitationTypeId === CONSTANT.INVITATION_TYPE.Telemedicine) {
            handleJoinTelemedicine(notification);
        } else {
            redirectToEditAssessmentPage(notification)
            // dispatch(setOpenChatBot({
            //     invitationData: notification,
            //     patientId,
            //     testIdToResumeChat: notification?.TestId,
            //     meetingStart: notification?.MeetingStart,
            //     meetingEnd: notification?.MeetingEnd
            // }));
        }
    }

    const setTelemedicineAlert = (conformationAlertContentRef) => {
        const assessmentAvailabilityStatus = getAssessmentAvailabilityStatus(notificationInformationOfSelectedAssessment.current?.MeetingStart, notificationInformationOfSelectedAssessment.current?.MeetingEnd);

        let yesBtnText = "";
        let handleOnClickYes = () => onClickJoinTelemedicine();

        if(assessmentAvailabilityStatus === CONSTANT.ASSESSMENT_AVAILABILITY.UPCOMING.KEY) {
            yesBtnText = CONSTANT.ASSESSMENT_AVAILABILITY.UPCOMING.MESSAGE;
            handleOnClickYes = () => handleOpenUpcomingOrExpiredPopupMessage(assessmentAvailabilityStatus, () => dispatch(setIsShowIsFollowUpPopup(false)));
        } else if(assessmentAvailabilityStatus === CONSTANT.ASSESSMENT_AVAILABILITY.EXPIRED.KEY) {
            yesBtnText = CONSTANT.ASSESSMENT_AVAILABILITY.EXPIRED.MESSAGE;
            handleOnClickYes = () => handleOpenUpcomingOrExpiredPopupMessage(assessmentAvailabilityStatus, () => dispatch(setIsShowIsFollowUpPopup(false)));
        } else {
            yesBtnText = CONSTANT.ASSESSMENT_AVAILABILITY.AVAILABLE.MESSAGES.JOIN_TELEMEDICINE;
        }

        const commonContent = getCommonAlertContentForInclinic();
        Object.assign(conformationAlertContentRef.current, {
            yesBtnText: yesBtnText,
            noBtnText: "Update My Background",
            content: commonContent,
            onClickYes: handleOnClickYes,
            onClickNo: () => handleOnClickNoAtFollowUpUpdateByBackgroundPopup(conformationAlertContentRef),
            headerText: "Update Your Information?"
        });
    };

    const setInClinicAlert = (conformationAlertContentRef) => {
        const commonContent = getCommonAlertContentForInclinic();
        Object.assign(conformationAlertContentRef.current, {
            noBtnText: "Update My Background",
            content: commonContent,
            onClickNo: () => handleOnClickNoAtFollowUpUpdateByBackgroundPopup(conformationAlertContentRef),
            headerText: "Update Your Information?",
            showYesBtn: false
        });
    };

    const setSelfInvitationAlert = (conformationAlertContentRef) => {
        const commonContent = getCommonAlertContentForInclinic();
        Object.assign(conformationAlertContentRef.current, {
            yesBtnText: "Resume Assessment",
            noBtnText: "Update My Background",
            content: commonContent,
            onClickYes: () => {
                openBiometricCautionQuestionModal(notificationInformationOfSelectedAssessment.current);
                dispatch(setIsShowIsFollowUpPopup(false));
                conformationAlertContentRef.current = {}
            },
            onClickNo: () => handleOnClickNoAtFollowUpUpdateByBackgroundPopup(conformationAlertContentRef),
            headerText: "Update Your Information?"
        });
    };

    const handleOnClickNoAtFollowUpUpdateByBackgroundPopup = (conformationAlertContentRef) => {
        dispatch(setIsShowIsFollowUpPopup(false));
        conformationAlertContentRef.current = {}
        redirectToEditAssessmentPage(notificationInformationOfSelectedAssessment.current);
    }

    const getCommonAlertContentForInclinic = () => (
        <div>
            <p>Would you like to update your background information (Activities of Daily Living, Medical History, Chief Complaints)?
                <span
                    onClick={() => dispatch(setShowDetailInstruction(true))}
                    className="edit-assessment-info-container kt-ml-10"
                >
                <img src={Info} alt="Information" className='tele_eye_btn cursor-pointer' />
            </span>
            </p>
        </div>
    );

    const onClickJoinTelemedicine = () => {
        handleJoinTelemedicine(notificationInformationOfSelectedAssessment.current);
        dispatch(setShowLoadingInConformTelemedicine(true));
        setIsShowIsFollowUpPopup(false);
    }

    const handleClickMore = (type) => {
        if(type === CONSTANT.ASSESSMENT_TYPE.FOLLOW_UP.key) {
            setFollowupForAssessmentPage(true);
        } else if(type === CONSTANT.ASSESSMENT_TYPE.LAST_INCOMPLETE.key) {
            setLastIncompletedAssessmentsForAssessmentPage(true);
        }

        // redirectTo(routes.myAssessments + '/false');
        history.push(routes.myAssessments + '/false');
    }

    const handleJoinTelemedicine = (notification) => {
        const isIntakeSigned = (GLOBAL.USER_INFO && GLOBAL.USER_INFO['IsIntakeSigned']) || false;
        dispatch(setIsShowIsFollowUpPopup(false));

        if(!isIntakeSigned && isIntakeTelemedicineFormEnable) {
            handleOpenIntakeForm({
                bodyRegionList: notification.BodyRegionList || [],
                invitationTypeName: notification.InvitationTypeName || '',
                showSubmitBtn: true,
                onClickSubmitIntakeForm: onClickSubmitIntakeForm
            })
        } else {
            joinTelemedicine(notification)
        }
    }

    const joinTelemedicine = (notification) => {
        handleCloseIntakeForm();
        setTelemedicineProperties(notification.InvitationId, notification.BodyRegionList, onOpenTelemedicineModal, onCloseTelemedicineModal);
        dispatch(setSelectedTelemedicineInvitationId(notification.InvitationId));
        dispatch(setShowLoadingAtJoinNowBtn(true));
    }



    const onClickSubmitIntakeForm = async (values) => {
        handleSetJoiningTelemedicine(true);
        GLOBAL.ASSESSMENT = new Assessment({ TestId: notificationInformationOfSelectedAssessment.current?.TestId });
        const response = await saveIntake(values);
        const { data, success, error } = response;
        if(!success) {
            toast.error(error || 'Failed to save intake form');
            return;
        }
        joinTelemedicine(notificationInformationOfSelectedAssessment.current);
    }

    const openBiometricCautionQuestionModal = (notification) => {
        dispatch(setOpenBiometricMovementAndCautionQuestionContainer({
            openBiometricMovementAndCautionQuestionContainer: true,
            testId: notification.TestId,
            selectedBodyRegions: notification.BodyRegionList
        }));
    }

    const onCloseTelemedicineModal = () => {
        resetTelemedicineKeys();
        dispatch(setSelectedTelemedicineInvitationId(null));
        dispatch(setShowLoadingAtJoinNowBtn(false));
        dispatch(setShowLoadingInConformTelemedicine(false));
    }

    const onOpenTelemedicineModal = () => {
        setIsShowIsFollowUpPopup(false);
    }

    const preparePayload = (BodyRegionList, InvitationId) => {
        return {
            BodyRegionList,
            InvitationId
        }
    }

    const removeURLQueryParams = () => {
        history.replace({ pathname: location.pathname });
    }

    return {
        handleNewUser,
        handleRemoteAssistance,
        notificationHandler,
        handleClickMore,
    }
}

export default useDashboardBody;
